/**
 * Alcance de división para usuarios NO transversales globales (tenant-context).
 * - `directDivisionIds`: asignación directa en el usuario-tenant.
 * - `effectiveDivisionIds`: directas + divisiones de roles custom.
 * Para elegir "división actual" usamos directas si hay; si no, efectivas (deduplicadas, orden estable).
 */

export type TenantAccessCtxLike = {
  isDivisionTransversalGlobal?: boolean;
  directDivisionIds?: string[];
  effectiveDivisionIds?: string[];
  /** Solo rol fijo `admin`: todas las divisiones del tenant (tenant-context). */
  allDivisionIds?: string[];
  /** Nombres de división (tenant-context); evita GET /division/:id que exige divisionRead. */
  divisionNamesById?: Record<string, string>;
};

export function getSelectableDivisionIds(ctx: TenantAccessCtxLike | null | undefined): string[] {
  if (!ctx) {
    return [];
  }
  const fromAll = (ctx.allDivisionIds || []).map(String).filter(Boolean);
  if (fromAll.length > 0) {
    return [...new Set(fromAll)];
  }
  if (ctx.isDivisionTransversalGlobal) {
    return [];
  }
  const direct = (ctx.directDivisionIds || []).map(String).filter(Boolean);
  const effective = (ctx.effectiveDivisionIds || []).map(String).filter(Boolean);
  const base = direct.length > 0 ? direct : effective;
  return [...new Set(base)];
}

export function shouldShowCurrentDivisionSwitcher(ctx: TenantAccessCtxLike | null | undefined): boolean {
  return getSelectableDivisionIds(ctx).length > 1;
}

/** Id a persistir: válido respecto a `allowed`, o el primero de la lista, o null si no aplica. */
export function reconcileCurrentDivisionId(
  ctx: TenantAccessCtxLike | null | undefined,
  storedId: string | null | undefined,
): string | null {
  const allowed = getSelectableDivisionIds(ctx);
  if (allowed.length === 0) {
    return null;
  }
  const s = storedId != null && storedId !== '' ? String(storedId) : null;
  if (s && allowed.includes(s)) {
    return s;
  }
  return allowed[0] ?? null;
}
